module.exports = __webpack_public_path__ + "img/plant.9efbe26e.png";